import { AddWallboxFormModel } from 'src/Libs/wallboxes/models'
import { AddWallboxDto } from 'src/Libs/wallboxes/dto/add-wallbox.dto'

const addSettingsFormToDtoTransformer = (model: AddWallboxFormModel): AddWallboxDto => ({
  ipAddr: model.ipAddress,
})
export default addSettingsFormToDtoTransformer
